import { render, staticRenderFns } from "./VoteDetail.vue?vue&type=template&id=ce2824ac"
import script from "./VoteDetail.vue?vue&type=script&lang=js"
export * from "./VoteDetail.vue?vue&type=script&lang=js"
import style0 from "./VoteDetail.vue?vue&type=style&index=0&id=ce2824ac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports